import React, { useEffect, useState } from 'react';
import { ApiRequest } from "GlobalFunctions";
import RoutesSummary from './components/RoutesSummary';
import VehicleChart from './components/VehicleChart';
import PaymentMethodsChart from './components/PaymentMethodsChart';
import Box from "elements/Box";
import DateRange from 'elements/DateRange';
import AutocompleteField from 'elements/AutocompleteField';
import moment from 'moment';

const OrdersDashboard = (props: any) => {
  const [summary, setSummary] = useState<any>({});
  const [shipmentsByVehicle, setShipmentsByVehicle] = useState<any[]>([]);
  const [paymentMethods, setPaymentMethods] = useState<any[]>([]);
  const [formValues, setFormValues] = useState<any>({
    date: {
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD")
    },
    license_plate: null,
    vehicle_id: null
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch routes dashboard data
        await ApiRequest({
          url: '/dashboard/getRoutesDashboard',
          method: 'get',
          headers: {
            'ltkn': localStorage.getItem('ltkn')
          },
          query: formValues,
          setResponse: (response: any) => {
            setSummary(response.summary);
            setShipmentsByVehicle(response.shipmentsByVehicle || []);
          }
        });

        // Fetch payment methods data
        await ApiRequest({
          url: '/dashboard/getPaymentMethods',
          method: 'get',
          headers: {
            'ltkn': localStorage.getItem('ltkn')
          },
          query: formValues,
          setResponse: (response: any) => {
            setPaymentMethods(response || []);
          }
        });
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      }
    };

    fetchData();
  }, [formValues]);

  return (
    <div id="Dashboard" className="ModuleContainer">
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h1>Rutas</h1>
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
              <DateRange
                className="filters_datePicker"
                label="Date range"
                variant="outlined"
                fullWidth
                value={{
                  startDate: formValues.date?.startDate || null,
                  endDate: formValues.date?.endDate || null,
                }}
                format="MMMM DD, yyyy"
                onChange={(e: any) => {
                  if (e.startDate && e.endDate) {
                    const startDate = moment(e.startDate).format("YYYY-MM-DD");
                    const endDate = moment(e.endDate).format("YYYY-MM-DD");

                    setFormValues({
                      ...formValues,
                      date: { startDate, endDate },
                    });
                  }
                }}
                variantDatePicker="side-by-side"
              />
              
              <AutocompleteField
                endpoint="/vehicles/list"
                label="Vehículo"
                value={formValues.vehicle_id}
                onChange={(value: any) => {
                  setFormValues({
                    ...formValues,
                    vehicle_id: value?.vehicle_id || null,
                  });
                }} 
                sx={{ minWidth: 200 }}
                renderValues={["license_plate", "vehicle_name"]}
              />
            </div>
          </div>
          <div className="boxContainerActions">
          </div>
        </div>

        <div id="DashboardIn">
          <RoutesSummary summary={summary} />
          <div className="dashboard_row">
            <PaymentMethodsChart paymentMethods={paymentMethods} />
            <VehicleChart shipmentsByVehicle={shipmentsByVehicle} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrdersDashboard;